import React from 'react';
import type ProjectSettingsServiceDeskChangeManagementType from '@atlassian/jira-spa-apps-project-settings-service-desk-change-management/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsServiceDeskChangeManagement = lazyForPaint<
	typeof ProjectSettingsServiceDeskChangeManagementType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-service-desk-change-management", jiraSpaEntry: "async-project-settings-service-desk-change-management" */ '@atlassian/jira-spa-apps-project-settings-service-desk-change-management'
		),
	),
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyProjectSettingsServiceDeskChangeManagement}
		pageId="project-settings-change-management"
		shouldShowSpinner
	/>
);
